// extracted by mini-css-extract-plugin
export default {"container":"MC-z","dimension":"NC-z","dimensionLabels":"OC-z"};